module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-100.f666249.woff";